import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { Spinner, StackView } from '@telus-uds/components-web';
import { FileUpload as UDSFileUpload } from '@telus-uds/components-base';

import request from '../../../../utils/request';
import { useLocalizedStringsContext } from '../../../../context/LocalizedStringsContext';
import { FieldLabelWrapper } from '../../css';
import FieldGuide from '../../common/fieldGuide';
import FieldTitle from '../../common/FieldTitle';
import { uploadCustomerReadinessChecklist } from '../../../../utils/constant';

const FileUpload = ({
  name,
  label,
  required,
  addFileToList,
  allowedFileTypes,
  maximumFileSize,
  orderId,
  tooltip
}) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    general: {
      fileUploadingError,
      uploading
    }
  } = localizedStrings;
  const [isUploading, setIsUploading] = useState(false);

  // Parse allowedFileTypes string like ".pdf,.doc" into array ['pdf', 'doc']
  const fileTypes = allowedFileTypes
    ? allowedFileTypes.split(',').map(t => t.trim().replace(/^\./, ''))
    : undefined;

  const renameFile = (originalFile, newName) => {
    return new File([originalFile], newName, {
      type: originalFile.type,
      lastModified: originalFile.lastModified
    });
  };

  const handleUpload = async (files) => {
    setIsUploading(true);
    const results = await Promise.all(files.map(async (originalFile) => {
      let file = originalFile;
      if (name === uploadCustomerReadinessChecklist) {
        const fileExtension = originalFile.type.replace(/(.*)\//g, '');
        file = renameFile(originalFile, `Customer readiness checklist.${fileExtension}`);
      }
      try {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('typeId', name);
        const result = await request.post(`/orders/${orderId}/upload-file`, formData);
        if (result) {
          const orderFile = result.data && result.data.orderFile;
          if (!orderFile) throw new Error();
          addFileToList(orderFile);
        }
        return originalFile;
      } catch (error) {
        return { name: originalFile.name, error: fileUploadingError };
      }
    }));
    setIsUploading(false);
    return results;
  };

  const handleDelete = async () => ({});

  return (
    <StackView space={2}>
      <FieldLabelWrapper>
        <FieldTitle required={required} label={label} />
        {tooltip && <FieldGuide tooltip={tooltip} />}
      </FieldLabelWrapper>
      <Spinner label={uploading} variant={{ size: 'small' }} show={isUploading} inline>
        <UDSFileUpload
          fileTypes={fileTypes}
          maxFileSize={maximumFileSize}
          onUpload={handleUpload}
          onDelete={handleDelete}
        />
      </Spinner>
    </StackView>
  );
};

FileUpload.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  required: PropTypes.bool.isRequired,
  addFileToList: PropTypes.func.isRequired,
  allowedFileTypes: PropTypes.string.isRequired,
  maximumFileSize: PropTypes.number.isRequired,
  orderId: PropTypes.number.isRequired,
  tooltip: PropTypes.string
};

FileUpload.defaultProps = {
  tooltip: ''
};

export default FileUpload;
